import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import GoodsModal from "./GoodsModal";
import { getPostCard } from "@/api";
import { useSearchParams } from "react-router-dom";

const GoodsList = ({ postCardList ,  onToggleLike }: { postCardList: any , onToggleLike: (postId: string) => void; }) => {


    const [searchParams, setSearchParams] = useSearchParams();
    const postcardIdParam = searchParams.get("postcardId");

    const [imageData, setImageData] = useState<string[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [postData, setPostData] = useState<any | null>(null);

    useEffect(() => {
        if (postcardIdParam && postCardList?.content) {
            const post = postCardList.content.find((p: any) => String(p.postCardId) === postcardIdParam);
            if (post) {
                setSelectedImage(post.postCardPhoto);
                setPostData(post);
                setIsModalOpen(true);
            }
        } else {
            setIsModalOpen(false);
        }
    }, [postcardIdParam, postCardList]);

    const openModal = (post: any) => {
        setSearchParams({ postcardId: String(post.postCardId) }, { replace: true });
    };

    const closeModal = () => {
        const newParams = new URLSearchParams(searchParams);
        newParams.delete("postcardId");
        setSearchParams(newParams, { replace: true });
    };

    return (
        <div className="w-full gap-[26px] flex flex-wrap ">
            {postCardList?.content?.map((image :any, idx :number) => (
                <div key={idx} >
                    <div
                        onClick={() => openModal(image)}
                        className="cursor-pointer w-[280px] h-[346px] shadow-md rounded-lg overflow-hidden ">
                        <img
                            className="w-full h-full object-cover"
                            src={image.postCardPhoto ? `data:image/png;base64,${image.postCardPhoto}` : "/img/profile_sam.jpg"}
                            alt={image.authorName ? `${image.authorName} 작가의 엽서${image.postCardDescription ? ` - ${image.postCardDescription}` : ""}` : "북밋 엽서"}
                        />
                    </div>

                    <div className="mb-10 mt-3 flex flex-row">
                        <div id="profile" className="flex items-center mr-24">
                            <img className="w-5 h-5 rounded-full inline-block"
                                 src={image.authorProfilePhoto ? `data:image/png;base64,${image.authorProfilePhoto}` : "/img/profile_sam.jpg"}
                                  alt=""/>
                            <span className="text-xs font-semibold ml-2">{image.authorName}</span>
                        </div>


                    </div>


                </div>

            ))}


            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Goods Modal"
                className="penpal-alert-goods"
                ariaHideApp={false}
                overlayClassName="overlay">
                <GoodsModal imageSrc={selectedImage}   postData={
                    Array.isArray(postCardList?.content)
                        ? postCardList.content.find((p: any) => p.postCardId === postData?.postCardId)
                        : null
                } closeModal={closeModal} onToggleLike={onToggleLike}   />
            </Modal>


        </div>
    );
};

export default GoodsList;
